// Module
var code = `<div appHeaderBar>
    <header-bar-title>Pay Amenities - Select Amenities</header-bar-title>
</div>

<app-page-content [showWebFooter]="true"
                  [usePagePadding]="true"
                  [pmcId]="property.hoa.pmc.couponId"
                  [hoaId]="property.hoa.couponId"
                  [propertyId]="property.couponId">
    <app-cobrand-header [property]="property.nickname"
                        [manager]="property.hoa.pmc.name"
                        [association]="property.hoa.name"
                        [makePayment]="true">
    </app-cobrand-header>

    <form name="vm.SelectAmenitiesForm" id="SelectAmenitiesForm" #selectAmenitiesForm="ngForm">
        <div class="HOA-container">
            <div class="HOA-container__header">
                <h1 tid="oneTimePaymentLabel" id="oneTimePaymentLabel" class="HOA-container__header-text">
                    Amenities Available
                </h1>
            </div>
            <div class="HOA-container__content">
                <div class="HOA-misc-guidedSteps__flex HOA-misc-guidedSteps__flex-padded HOA-misc-guidedSteps__flex-align-bottom u-pT5">
                    <div class="Field HOA-misc-guidedSteps__flex-child HOA-make-payment-w100">
                        <label class="Field-label" for="amenityCategorySelect">
                            Category
                        </label>
                        <div class="Select">
                            <select tid="amenityCategorySelect"
                                    id="amenityCategorySelect"
                                    name="amenityCategorySelect"
                                    [(ngModel)]="selectedCategory"
                                    (change)="changeSelectedCategory()">
                                <option *ngFor="let category of availableCategories" [ngValue]="category">
                                    {{category.description}}
                                </option>
                            </select>
                            <span class="Select-arrow"></span>
                        </div>
                    </div>
                    <span class="HOA-make-guidedSteps_middleColumn"> </span>
                    <div class="HOA-misc-guidedSteps__flex-child HOA-make-payment-w100"></div>
                </div>
                <div class="HOA-misc-guidedSteps__flex HOA-misc-guidedSteps__flex-padded HOA-misc-guidedSteps__flex-align-bottom">
                    <div class="Field HOA-misc-guidedSteps__flex-child HOA-make-payment-w100">
                        <label class="Field-label" for="amenitySelect">
                            Amenity
                        </label>
                        <div class="Select">
                            <select tid="amenitySelect"
                                    id="amenitySelect"
                                    name="amenitySelect"
                                    [(ngModel)]="selectedAmenity">
                                <option [ngValue]=""></option>
                                <option *ngFor="let amenity of filteredAmenities" [ngValue]="amenity">
                                    {{amenity.description + ' \$' + amenity.totalAmount }}
                                </option>
                            </select>
                            <span class="Select-arrow"></span>
                        </div>
                    </div>
                    <span class="HOA-make-guidedSteps_middleColumn"> </span>
                    <div class="Field HOA-misc-guidedSteps__flex-child">
                        <button id="addAmenityButton"
                                tid="addAmenityButton"
                                name="addAmenityButton"
                                [disabled]=""
                                class="Button Button--blue HOA-make-payment-button"
                                ifOverFlowXClass="Button--overflowX"
                                (click)="addAmenityToCart()">
                            Add
                        </button>
                    </div>
                </div>
                <div tid="shoppingCartLabel" id="shoppingCartLabel"
                     class="HOA-flextable-component__subheader u-mT3 u-mB7">
                    Shopping Cart
                </div>
                <div class="HOA-propertyblock-flextable">
                    <div *ngIf="cartItems.length <= 0"
                         class="HOA-propertyblock-flextable__cell
                                        HOA-propertyblock-flextable__cell--list
                                        HOA-propertyblock-flextable__cell--100
                                        HOA-propertyblock-flextable--truncate">
                        <div class="HOA-propertyblock-flextable__cell-value HOA-propertyblock-flextable--truncate"
                             tid="emptyCart">
                            Your shopping cart is empty.
                        </div>
                    </div>
                    <ng-container *ngFor="let cartItem of cartItems">
                        <div class="HOA-propertyblock-flextable__cell
                                            HOA-propertyblock-flextable__cell--list
                                            HOA-propertyblock-flextable__cell--40
                                            HOA-propertyblock-flextable--truncate">
                            <div class="HOA-propertyblock-flextable__cell-value-darker
                                                HOA-propertyblock-flextable--truncate"
                                 tid="description">
                                {{ cartItem.description }}
                            </div>
                        </div>
                        <div class="HOA-propertyblock-flextable__cell
                                            HOA-propertyblock-flextable__cell--list
                                            HOA-propertyblock-flextable__cell--20
                                            HOA-propertyblock-flextable--truncate">
                            <div class="HOA-propertyblock-flextable__cell-value-darker
                                                HOA-propertyblock-flextable--truncate"
                                 tid="amount">
                                {{ cartItem.amount | currency:"\$" }}
                            </div>
                        </div>
                        <div class="HOA-propertyblock-flextable__cell
                                            HOA-propertyblock-flextable__cell--list
                                            HOA-propertyblock-flextable__cell--25
                                            HOA-propertyblock-flextable--truncate">
                            <div [ngClass]="{ 'is-invalid': cartItem.qtyError }"
                                 class="Field
                                                HOA-propertyblock-flextable__cell-value-no-margin
                                                HOA-propertyblock-flextable--truncate u-mB2 u-pB0"
                                 tid="qty">
                                <button class="Button--teal Button--small" (click)="decrementQty(cartItem)">
                                    -
                                </button>
                                <input id="{{ cartItem.entityId }}-qty"
                                       name="{{ cartItem.entityId }}-qty"
                                       type="number"
                                       class="Input qty-input"
                                       [(ngModel)]="cartItem.qty"
                                       min="1"
                                       max="9999"
                                       allow-pattern="\\d"
                                       (change)="updateTotal();amenityService.validateCartItem(cartItem);onCartItemUpdate.emit()">
                                <button class="Button--teal Button--small" (click)="incrementQty(cartItem)">
                                    +
                                </button>
                                <div class="Field-error u-textCenter"
                                     id="{{ cartItem.entityId }}-qty-error">{{ cartItem.qtyError }}
                                </div>
                            </div>
                        </div>
                        <div class="HOA-propertyblock-flextable__cell
                                            HOA-propertyblock-flextable__cell--list
                                            HOA-propertyblock-flextable__cell--15
                                            HOA-propertyblock-flextable--truncate">
                            <div class="HOA-propertyblock-flextable__cell-value u-margin-right-align">
                                <button type="button"
                                        (click)="deleteCartItem(cartItem)"
                                        class="payment-history-payment-method-code-label
                                                        Button--link HOA-payment-history-button"
                                        tid="delete">
                                    Delete
                                </button>
                            </div>
                        </div>
                        <div *ngIf="cartItem.displayNotes"
                             class="HOA-propertyblock-flextable__cell
                                     HOA-propertyblock-flextable__cell--list
                                     HOA-propertyblock-flextable__cell--100">
                            <div class="HOA-propertyblock-flextable__cell-value u-pL3" tid="displayNotes">
                                {{ cartItem.displayNotes }}
                            </div>
                        </div>
                        <div class="HOA-propertyblock-flextable__cell
                                            HOA-propertyblock-flextable__cell--list
                                            HOA-propertyblock-flextable__cell--100">
                            <div class="HOA-propertyblock-flextable__cell-value u-pL3" tid="payerNotes">
                                <button type="button"
                                        (click)="addEditNote(cartItem)"
                                        class="payment-history-payment-method-code-label Button--link"
                                        tid="addNote">
                                    {{ cartItem.payerNotes ? 'Edit Note' : 'Add Note'}}
                                </button>
                            </div>
                        </div>
                    </ng-container>
                </div>
                <div class="HOA-container__content-hrule
                                    HOA-propertyblock-flextable__cell
                                    HOA-propertyblock-flextable__cell--100 u-mT5">
                </div>
                <div class="HOA-propertyblock-flextable__cell HOA-propertyblock-flextable__cell--100">
                    <div class="HOA-propertylanding-content__subheader">
                        Order Total
                        <span class="asterisk-required">&nbsp;*</span>
                    </div>
                    <div class="u-margin-right-align">
                                <span tid="itemsTotal" id="itemsTotal" class="HOA-make-payment-amount-owed">
                                    {{itemsTotal | currency:"\$"}}
                                </span>
                    </div>
                </div>
				<div *ngIf="amenityAmtErrorMsg" class="u-pT2 HOA-flex-component Field-error">
                	{{amenityAmtErrorMsg}}
                </div><br>

                <div class="u-pT2 HOA-flex-component HOA-font-fine-print">
                            <span
                                    class="asterisk-required">*
                            </span>
                    &nbsp;May include administrative fees
                </div>
            </div>
        </div>
        <div class="HOA-flex-component HOA-flex-component__column-center u-pT10">
            <div class="HOA-flex-component HOA-guest-payment-button-container">
                <button name="payByCheck"
                        id="payByCheck"
                        tid="payByCheck"
                        type="button"
                        (click)="submit('check')"
                        class="Button Button--blue "
                        [disabled]="selectAmenitiesForm.invalid || (cartItems && amenityService.invalid(cartItems)) || amenityAmtErrorMsg"
                        *ngIf="allowPayByCheck">
                    <span>Pay by eCheck</span>
                </button>
                <button name="payByCard"
                        id="payByCard"
                        tid="payByCard"
                        type="button"
                        (click)="submit('card')"
                        class="Button Button--blue "
                        [disabled]="selectAmenitiesForm.invalid || (cartItems && amenityService.invalid(cartItems)) || amenityAmtErrorMsg"
                        *ngIf="allowPayByCard">
                    <span>Pay by Card</span>
                </button>
            </div>
            <button name="back"
                    id="back"
                    tid="back"
                    type="button"
                    class="Button Button--link HOA-guest-payment-cancel-button"
                    (click)="onClickBack()">
                Back
            </button>
        </div>
    </form>
</app-page-content>
`;
// Exports
module.exports = code;